import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const LONG_VALUE_THRESHOLD = 140;
export const ROW_MIN_HEIGHT = 36;

export const useStyles = tss.create(({ theme }) => ({
  actions: {
    flexWrap: 'wrap',
  },
  viewer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(1.25),
    maxHeight: '52vh',
    overflow: 'auto',
    backgroundColor: theme.palette.background.default,
    '& > .MuiStack-root > :last-child, & .MuiStack-root > :last-child > .MuiButtonBase-root, & .MuiStack-root > :last-child > .MuiBox-root':
      {
        borderBottom: 'none',
      },
  },
  emptyState: {
    color: theme.palette.text.secondary,
  },
  primitiveRow: {
    minHeight: ROW_MIN_HEIGHT,
    display: 'grid',
    gridTemplateColumns: '18px 1fr',
    borderRadius: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.hover, 0.6),
    },
  },
  primitiveContent: {
    justifyContent: 'center',
  },
  primitiveValue: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: 1.45,
  },
  primitiveLabel: {
    fontWeight: 600,
  },
  primitiveToggle: {
    alignSelf: 'flex-start',
    cursor: 'pointer',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    '&:hover': {
      color: theme.palette.text.primary,
    },
    '&:focus-visible': {
      outline: `2px solid ${alpha(theme.palette.primary.main, 0.35)}`,
      outlineOffset: 2,
    },
  },
  branchButton: {
    width: '100%',
    minHeight: ROW_MIN_HEIGHT,
    display: 'grid',
    gridTemplateColumns: '18px 1fr auto',
    alignItems: 'center',
    textAlign: 'left',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.hover, 0.6),
    },
  },
  branchButtonExpanded: {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
    },
  },
  branchChevron: {
    color: theme.palette.text.secondary,
  },
  branchTitle: {
    fontWeight: 500,
    wordBreak: 'break-word',
    lineHeight: 1.35,
  },
  branchTitleExpanded: {
    fontWeight: 600,
  },
  branchMeta: {
    paddingLeft: theme.spacing(1),
    flexShrink: 0,
    color: theme.palette.text.secondary,
  },
  children: {
    gap: theme.spacing(0.25),
  },
}));
